module.exports = __webpack_public_path__ + "b1c0f9db2123d7c73421cb2e12fafae7.pdf";